import React from 'react';
import PropTypes from 'prop-types';

import { defineMessages, injectIntl } from 'react-intl';

import Segment from '../../components/Segment';
import './styles.css';

const messages = defineMessages({
  noResultsMessage: {
    id: 'repvisits.contacts.no-seults.message',
    defaultMessage: 'Your search did not return any contacts.',
  },
});

const ContactsListNoResults = ({ intl }) => (
  <Segment>
    <div styleName="empty-welcome">
      <p styleName="empty-welcome-message">{intl.formatMessage(messages.noResultsMessage)}</p>
    </div>
  </Segment>
);

ContactsListNoResults.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(ContactsListNoResults);
